<div class="label justify-end">
  {{
    'communication.message.system.cases.type-changed'
      | translate: { old: this.case().OldType ?? '', new: this.case().NewType ?? '' }
  }}
</div>
